import { Injectable } from '@angular/core';

import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PingServerService {

  private baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) {
  }

  pingServer(): Observable<Object> {
    return this.http.get(`${this.baseUrl}` + `Ping/`, {responseType: 'text'});
  }


}
